// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderUploadStyles } from "@insite/content-library/Components/OrderUpload";
import { getNotifyStyle } from "@keller/App/Components/Notify";
import { xScreen } from "@keller/XDL/Utilities";
import { css } from "styled-components";

orderUploadStyles.downloadTemplateButton = {
    css: css`
        margin-bottom: 15px;
    `,
    variant: "secondary",
};

orderUploadStyles.includeFirstRowCheckbox = {
    css: css`
        margin: 15px 0 40px;
        display: flex;
    `,
};

orderUploadStyles.cancelUploadButton = {
    ...orderUploadStyles.cancelUploadButton,
    variant: "secondary",
};

orderUploadStyles.fileUploader = {
    buttonProps: {
        variant: "primary",
    },
};

orderUploadStyles.mainWrapper = {
    css: css`
        div[class^="UploadWrapper"] {
            margin-top: 20px;
            ${xScreen("lte", "xs")} {
                [class^="ButtonWrapper"] {
                    margin-left: 0;
                    width: 100%;
                }
            }
        }
    `,
};

orderUploadStyles.uploadFileButton = {
    css: css`
        margin-right: 10px;
        ${xScreen("lte", "xs")} {
            width: 100%;
            margin-right: 0;
            margin-bottom: 10px;
        }
    `,
};

orderUploadStyles.cancelUploadButton = {
    variant: "secondary",
    css: css`
        ${xScreen("lte", "xs")} {
            width: 100%;
        }
    `,
};

orderUploadStyles.spinner = {
    size: 16,
    css: css`
        vertical-align: sub;
    `,
};

orderUploadStyles.uploadingButtonLabel = {
    css: css`
        margin-left: 15px;
        vertical-align: revert;
    `,
};

orderUploadStyles.uploadFileButtonLabel = {
    size: 12,
    css: css``,
};

orderUploadStyles.orderCancellationSuccessfulText = {
    ...getNotifyStyle("warning"),
};
